export default {"src":"/_next/static/media/login-unassisted.66a11322.svg","height":292,"width":316,"blurWidth":0,"blurHeight":0};